import styled from 'styled-components';

export const ViewerAiContainer = styled.div`
  width: 100%;
  height: 100%;
`;
